export default {
    methods: {
        findObjectStatusIconStyles(status) {
            return {
                'fa-check': status.value === 'approved',
                'fa-clock': status.value === 'pending',
                'fa-times': status.value === 'rejected',
                ...this.findObjectStatusStyles(status)
            }
        },

        findObjectStatusStyles(status) {
            return {
                'text-green': status.value === 'approved',
                'text-orange': status.value === 'pending',
                'text-red': status.value === 'rejected',
            }
        }
    }
}